var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ChatTextIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 53,
    glyphHeight: 49
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18476 6.01008V41.2149L12.5073 35.9C12.7656 35.6828 13.0599 35.5126 13.377 35.3971L14.2644 35.0736C14.5814 34.9581 14.9163 34.899 15.2537 34.899H46.6292V6.01008H6.18476ZM1.81721 1.64253C2.72016 0.739575 3.94483 0.2323 5.2218 0.2323H47.5922C48.8691 0.2323 50.0938 0.739573 50.9968 1.64253C51.8997 2.54548 52.407 3.77015 52.407 5.04711V35.8619C52.407 37.1389 51.8997 38.3636 50.9968 39.2665C50.0938 40.1695 48.8691 40.6767 47.5922 40.6767H15.804L8.32003 46.968C7.61817 47.558 6.76245 47.9354 5.85349 48.0557C4.94452 48.1759 4.0201 48.0342 3.18894 47.6471C2.35777 47.26 1.65443 46.6436 1.16161 45.8704C0.668786 45.0972 0.406982 44.1993 0.406982 43.2825V5.04711C0.406982 3.77014 0.914258 2.54548 1.81721 1.64253Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8145 15.6397C15.8145 14.0443 17.1079 12.7509 18.7033 12.7509H34.1107C35.7062 12.7509 36.9996 14.0443 36.9996 15.6397C36.9996 17.2352 35.7062 18.5286 34.1107 18.5286H18.7033C17.1079 18.5286 15.8145 17.2352 15.8145 15.6397Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8145 25.2694C15.8145 23.6739 17.1079 22.3805 18.7033 22.3805H34.1107C35.7062 22.3805 36.9996 23.6739 36.9996 25.2694C36.9996 26.8649 35.7062 28.1583 34.1107 28.1583H18.7033C17.1079 28.1583 15.8145 26.8649 15.8145 25.2694Z"
  }));
};
export var ChatTextIconGlyph = function (props) {
  return React.createElement(ChatTextIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};